"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderItemAttributesFullSchema = void 0;
const zod_1 = require("zod");
const add_on_1 = require("./add_on");
const order_item_1 = require("./order_item");
const product_item_full_1 = require("./product_item_full");
exports.OrderItemAttributesFullSchema = order_item_1.OrderItemAttributesSchema.merge(zod_1.z.object({
    AddOn: add_on_1.AddOnAttributesSchema.nullable().optional(),
    ProductItem: product_item_full_1.ProductItemAttributesFullSchema.nullable().optional(),
}));
//# sourceMappingURL=order_item_full.js.map